import { render, staticRenderFns } from "./WhyRentWithUs.vue?vue&type=template&id=ed4fdcd2&scoped=true&"
import script from "./WhyRentWithUs.vue?vue&type=script&lang=ts&"
export * from "./WhyRentWithUs.vue?vue&type=script&lang=ts&"
import style0 from "./WhyRentWithUs.vue?vue&type=style&index=0&id=ed4fdcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4fdcd2",
  null
  
)

export default component.exports